import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Mail } from 'lucide-react';

export default function EmailStep({ email, setEmail, loading, onSubmit, onBack }) {
  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-email-step">
      <p className="text-sm text-emerald-700 mb-2">
        Enter your admin email and we'll send you a 5-digit verification code.
      </p>
      <div>
        <Label htmlFor="forgot-email" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          Email
        </Label>
        <div className="relative">
          <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <Input
            id="forgot-email"
            data-testid="forgot-email-input"
            type="email"
            placeholder="you@smashzone.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-14 rounded-2xl bg-secondary border-transparent pl-12"
            required
            autoFocus
          />
        </div>
      </div>
      <Button
        type="submit"
        data-testid="forgot-email-submit-button"
        className="w-full btn-volt h-14 mt-6"
        disabled={loading}
      >
        {loading ? 'Sending...' : 'Send verification code'}
      </Button>
      <div className="pt-4 border-t text-center">
        <Button type="button" variant="ghost" onClick={onBack} className="text-sm" data-testid="forgot-back-to-login-button">
          ← Back to Login
        </Button>
      </div>
    </form>
  );
}
